<template>
<div >
<el-row class='post_content'>
        <el-row>
            <el-col :span="24" class='content_top'>
                <p class='warn'>报名单未支付时间超过30分钟后将自动清除！！</p>
                <!-- <br>系统报名时间：<span>{{signStartTime}}</span> 至 <span>{{signEndTime}}</span> -->
            </el-col>
        </el-row>
        <el-row style="margin-bottom:20px;">
            <el-col :span="15" class='content_desc'>
                <el-form label-width="180px" ref="ruleForm" :model="formData" :rules="rules" class='fillForm'>
                    <el-form-item label="身份证号码" class="lab_icon lab" prop="cardCode">
                        <el-input type="text" placeholder="请输入身份证号" @blur="checknumMinusp2($event)" v-model="formData.cardCode" ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <div >
                            <p>（*无居民身份证的可输入护照号）</p>
                       </div>  
                     </el-form-item>
                    <el-form-item label="姓名" class="lab_icon lab" prop="name">
                        <el-input type="text"  placeholder="请输入姓名" v-model="formData.name"></el-input>
                    </el-form-item>
                    <el-form-item label="出生日期" class="lab_icon lab" prop="birthday_m">
                        <el-form-item prop="date1">
                            <el-date-picker type="date" placeholder="出生日期" v-model="formData.birthday_m"  style="width: 100%;"></el-date-picker>
                        </el-form-item>
                    </el-form-item>
                    <el-form-item label="性别" class="lab_icon lab" prop="sex">
                        <el-radio-group v-model="formData.sex">
                            <el-radio label="男">男</el-radio>
                            <el-radio label="女">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="联系人" class="lab_icon lab" prop="contact">
                        <el-input v-model="formData.contact" placeholder="请输入联系人" ></el-input>
                    </el-form-item>
                    <el-form-item label="联系电话" class="lab_icon lab" prop="phone">
                        <el-input v-model="formData.phone" placeholder="请输入联系电话"></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" class="select" prop="email">
                        <el-input v-model="formData.email" placeholder="请输入邮箱"></el-input>
                    </el-form-item>
                    <el-form-item label="指导老师" class="select" prop="teacher">
                        <el-input v-model="formData.teacher" placeholder="请输入指导老师"></el-input>
                    </el-form-item>
                    <el-form-item label="指导老师电话" class="select" prop="teacherPhone">
                        <el-input v-model="formData.teacherPhone" placeholder="请输入指导老师电话"></el-input>
                    </el-form-item>
                    <el-form-item label="证书收件地址" class="lab_icon lab" prop="address">
                        <el-input v-model="formData.address" placeholder="请输入考级证书收件地址"></el-input>
                    </el-form-item>
                    <el-form-item label="邮政编码" class="lab_icon lab" prop="postCode">
                        <el-input v-model="formData.postCode"  placeholder="请输入邮政编码"></el-input>
                    </el-form-item>
                    <el-form-item label="报考点" class="lab_icon lab" prop="cityIdPath">
                        <el-cascader
                            placeholder="请选择下属单位"
                            :options="areaOptions"
                            v-model="formData.cityIdPath"
                            @change="onAreaChange">
                        </el-cascader>
                    </el-form-item>

                    <el-form-item
                            label="考点"
                            class="lab_icon lab">
                        <el-select
                                optionFilterProp="name"
                                v-model="formData.placeId"
                                placeholder="选择考点"
                                @change="onPlaceIdChange"
                        >
                            <el-option :key="option.id" v-for="option in placeOptions" :title="option.name"   :value="option.id" :label="option.name">{{option.name}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="报考类型" class="lab_icon lab">
                        <el-radio-group v-model="formData.sign_type" @change="onSignTypeChange" buttonStyle="solid">
                            <el-radio-button :label="1">科目级别</el-radio-button>
                            <el-radio-button :label="2">乐理单试</el-radio-button>
                        </el-radio-group> 
                    </el-form-item>
                    <el-form-item
                            v-show="formData.sign_type==1"
                            label="专业科目">
                        <el-select
                                optionFilterProp="name"
                                v-model="formData.subjectId"
                                placeholder="选择科目"
                                @change="onSubjectChange"
                        >
                            <el-option :key="option.id" v-for="option in subjectOptions" :title="option.name"   :value="option.id" :label="option.name">{{option.name}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                            v-show="formData.sign_type==1"
                            label="级别"
                    >
                    <el-select
                                optionFilterProp="title"
                                v-model="formData.subjectLevelId"
                                placeholder="选择级别"
                                @change="onLevelChange"
                        >
                            <el-option :key="option.id" v-for="option in levelOptions" :title="option.name"  :value="option.id" :label="option.name">{{option.name}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item
                            v-show="formData.sign_type==2"
                            label="乐理"
                    >
                        <el-select
                                optionFilterProp="title"
                                v-model="formData.theoryId"
                                @change="onTheoryChange"
                                placeholder="选择乐理"
                        >
                            <el-option :key="option.id" v-for="option in theoryOptions" :title="option.name" :disabled="option.disabled" :value="option.id" :label="option.name">{{option.name}}</el-option>
                        </el-select>
                        <span v-if="formData.theoryId"
                            label="包含项目" v-html='formData.note'></span>
                    </el-form-item>
                    <el-form-item
                            v-show="formData.sign_type==2&&formData.theoryId!=''"
                            label="包含项目">
                            <span :key="option.id" v-for="option in theoryOptions"  :value="option.id" v-show='formData.theoryId==option.id' v-html='option.note'></span>
                    </el-form-item>
                    <el-form-item
                            label="辅导课"
                            v-show="tutorialOptions.length>0"
                    >
                        <el-select
                                optionFilterProp="title"
                                multiple
                                v-model="formData.turoialIdsArray"
                                placeholder="选择辅导课"
                                @change="onTuroialChange"
                        >
                            <el-option :key="option.id" v-for="option in tutorialOptions" :title="option.name" :disabled="option.disabled" :value="option.id" :label="option.name">{{option.name}}</el-option>
                        </el-select>    
                    </el-form-item>
                   <el-form-item v-show="formData.turoialIdsArray.length>0">
                       <div v-for="(optionDes,index) in tutorialList" :key='index'>
                            <p class="boldName">{{optionDes.name}}</p>
                            <p>上课时间：{{optionDes.courseHint}}</p>
                            <p>考试时间：{{optionDes.examHint}}</p>
                            <p>{{optionDes.des}}</p>
                            <p>剩余：{{optionDes.count}}个座位</p>
                       </div>   
                    </el-form-item>
                    <el-form-item label="费用" >
                        <p v-html="sumPrice.priceInfo"></p>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input
                            type="textarea"
                            :rows="5"
                            placeholder="三年内（含当年）8级及以上级别，所报器乐或乐理成绩合格的考生，请将已通过的准考证号备注在此，以便核实。"
                            v-model="formData.des">
                        </el-input>
                    </el-form-item>
                </el-form> 
            </el-col>
            <el-col :span="9" style="text-align:center;">
                <el-upload
                    class="avatar-uploader"
                    action=""
                    accept=".jpg,.png"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforePicUpload">
                    <img v-if="formData.pic" :src="formData.pic|picUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <p class='size'>标准证件照的尺寸：<br>390宽 * 567高<br>请自行裁剪！</p>
                <el-upload
                    v-show="picAuditShow"
                    class="avatar-uploader"
                    action=""
                    accept=".jpg,.png"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="beforePicAuditUpload">
                    <img v-if="formData.picAudit" :src="formData.picAudit|picUrl" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
                <p  v-show="picAuditShow" class='size'>标准审核照片的尺寸：<br>390宽 * 567高<br>请自行裁剪！</p>
            </el-col>
        </el-row>
        <div style="text-align:center;padding-bottom:30px;">
            <el-button class='saveBtn' type="primary" :loading="saveLoading" @click="submitForm('ruleForm')">报名</el-button>
        </div>
    </el-row>
    <PayDialog :signId="signId" :visible="payVisible" @payCancel="payCancel" @payDone="payDone"></PayDialog>
    <el-dialog title="报名信息" :visible.sync="dialogSignVisible" class='diabor'>
        <div style='display:flex;'>
            <div  class='signInfo' style='width:70%;'>
                <!-- <div class='signInfo'> -->
                    <p>姓名：{{confirmSign.name}}</p>
                    <p>性　别：{{confirmSign.sex}}</p>
                    <p>证件号：{{confirmSign.cardCode}}</p>
                    <p>出生日期：{{confirmSign.birthday}}</p>
                    <p>证书收件地址：{{confirmSign.address}}</p>
                    <p>报考点：{{confirmSign.cityName}}</p>
                <!-- </div>
                <div class='signInfo'> -->
                    <p>联系人：{{confirmSign.contact}}</p>
                    <p>联系电话：{{confirmSign.phone}}</p>
                    <p v-if="confirmSign.email">邮箱：{{confirmSign.email}}</p>
                    <p>邮政编码：{{confirmSign.postCode}}</p>
                    <p v-if="confirmSign.teacher">指导老师：{{confirmSign.teacher}}</p>
                    <p v-if='confirmSign.teacherPhone'>指导老师电话：{{confirmSign.teacherPhone}}</p>
                    <p>考点：{{confirmSign.placeName}}</p>
                    <div class='pStyle'>
                        <p v-if="formData.sign_type==1">
                            科目级别：{{confirmSign.subjectName}}<br>
                            {{confirmSign.subjectLevelName}}<br>
                            <span v-if='formData.turoialIdsArray.length>0'>
                                {{formData.tutorialNames}}
                            </span>
                        </p>
                        <p v-else>乐理单试：{{confirmSign.theoryName}}<br>
                            <span v-if='formData.turoialIdsArray.length>0'>
                                {{confirmSign.tutorialNames}}
                            </span>
                        </p>
                    </div>
                    <p>费用详情：<span v-html='sumPrice.priceInfo'></span></p>
                    <p>总费用：<span v-html='sumPrice.price'></span>元</p>
                <!-- </div> -->
            </div>
            <div style='width:30%;'>
                <div style='padding:5px 0;width:160px;'>
                    <img :src="formData.pic|picUrl" style='width:100%;height:200px;'>
                </div>
                <div>
                    <div v-if="picAuditShow" style='width:160px;'>
                        <img :src="formData.picAudit|picUrl" style='width:100%;height:200px;'>
                    </div>
                    <div v-else>
                    </div> 
                </div>  
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogSignVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmData">确 定</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import { getCityAllList,getTimeChange } from '@/utils/filter'
import moment from 'moment'
import PayDialog from '@/components/PayDialog.vue'
export default {
    components: {
        PayDialog
    },
    data() {
        const idCardPass = (rule, value, callback) => {
            let  reg = /^[0-9A-Za-z]{8,18}$/
        // let reg =/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/; 
        console.log(reg.test(value));
            if (value === '') {
                callback(new Error('证件号不能为空'));
            }else if(!reg.test(value)){
                callback(new Error('请输入正确的证件号'));
            }else{
                callback();
            }
        };
        return {
            signId:'',
            payVisible:false,
            saveLoading:false,
            picAuditShow:false,
            sumPrice:'-',
            signStartTime:'',
            signEndTime:'',
            areaOptions:[],
            placeOptions:[],//考点
            subjectOptions:[],//科目
            levelOptions:[],//级别
            theoryOptions:[],//乐理
            signGroupOptions:[],//集体
            tutorialOptions:[],//辅导课
            tutorialList:[],//辅导课列表展示
            dialogSignVisible:false,//报名模态框
            formData:{
                pic:'',
                picAudit:'',
                cardCode:'',
                birthday:'',
                birthday_m:undefined,
                name:'',
                phone:'',
                sex:'',
                contact:'',
                address:'',
                postCode:'',
                email:'',
                placeId:'',
                cityIdPath:[],
                title:'',
                sign_type:1,
                turoialIdsArray:[],
                cityId:'',
                desc:'',
                theoryId:'',
                note:'',
                teacher:'',
                teacherPhone:'',
                courseHint:'',
                examHint:'',
                des:'',
            },
            confirmSign:{
                name:'',
                sex:'',
                cardCode:'',
                birthday:'',
                address:'',
                cityName:'',
                placeName:'',
                teacher:'',
                teacherPhone:'',
                theoryName:'',
                pic:'',
                picAudit:'',
                phone:'',
                contact:'',
                postCode:'',
                tutorialNames:'',
                subjectName:'',
                subjectLevelName:'',
                price:''
            },
            name:'',
            identity:'',
            data:'',
            radio: '1',
            contact:'',
            phone:'',
            address:'',
            code:'',
            textarea: '',
            imageUrl: '',
            value1: [],
            rules: {
                name: [
                    {required: true, message: '请输入姓名', trigger: 'blur'},
                ],
                cardCode: [
                    //   {required: true, message: '请输入身份证号或护照号', trigger: 'blur'},
                    {validator: idCardPass, trigger: 'blur'},
                ],
                sex: [
                    {required: true, message: '请选择性别', trigger: 'blur'},
                ],
                contact: [
                    {required: true, message: '请输入联系方式', trigger: 'blur'},
                ],
                birthday_m: [
                    {required: true, message: '请输入生日', trigger: 'blur'},
                ],
                phone: [
                    {required: true, message: '请输入联系电话', trigger: 'blur'},
                ],
                address: [
                    {required: true, message: '请输入考级证书收货地址', trigger: 'blur'},
                ],
                postCode: [
                    {required: true, message: '请输入邮政编码', trigger: 'blur'},
                ],
                placeId: [
                    {required: true, message: '请选择考点', trigger: 'blur'},
                ]
            }
        }
    },
    mounted(){
        let that = this;
        that.fetch();
        that.parameter();
    },
    methods: {
        //报名时间
        parameter(){
            let self = this;
            window.Global.get('/parameter/info',null,rs => {
                console.log(rs.data.result)
                if(rs.data.status==200){
                    self.signStartTime = getTimeChange(rs.data.result.signStartTime);
                    self.signEndTime = getTimeChange(rs.data.result.signEndTime);
                    console.log(getTimeChange(rs.data.result.signStartTime))
                }else{
                    
                }
            })
        },
        //身份证失去焦点
        checknumMinusp2(e){
            console.log(e)
             let reg = /^[0-9A-Za-z]{8,18}$/
          // let reg =/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/; 
            if(reg.test(this.formData.cardCode)){
                console.log(reg.test(this.formData.cardCode))
                this.getSumPirce();
                let that = this;
                window.Global.get('/user/userByCard',{
                    'cardCode':that.formData.cardCode,
                },rs => {
                console.log(that.formData.cardCode)
                console.log(rs.data.result)
                    if(rs.data.status==200){
                        that.formData.name = rs.data.result.name
                        that.formData.birthday_m=rs.data.result.birthday
                        that.formData.contact=rs.data.result.contactor
                        that.formData.phone=rs.data.result.phone
                        that.formData.sex=rs.data.result.sex
                    }else{
                        
                    }
                })
            }   
        },
        //联动
        fetch(){
            let that = this;
            window.Global.get('/city/list',{
                status: 1
            },rs => {
                console.log(rs);
                if(rs.status==200){
                    console.log(getCityAllList(rs.data.result.children))
                    that.areaOptions = getCityAllList(rs.data.result.children)
                }
            })
        },
        onAreaChange(value){
            console.log('onAreaChange');
            console.log(value);
            let that = this;
            if(!value){
                return ;
            }
            //查询考点
            window.Global.get('/place/findByCity',{
                id:value[value.length-1], 
                status: 2
            },rs => {
                console.log(rs);
                if(rs.status==200){
                    that.placeOptions =  rs.data.result;
                    console.log(that.placeOptions);
                }
            })
        },
        onSignTypeChange(){
             //清空辅导课
            this.tutorialList = []
             this.sumPrice = '-';
              this.formData.turoialIdsArray = []
            let that = this;
            that.getTutorialOptions();
              
        },
        onTheoryChange(){
                //清空辅导课
            this.tutorialList = []
             this.sumPrice = '-';
              this.formData.turoialIdsArray = []
            let that = this;
            that.getTutorialOptions();
           
        },
        onLevelChange(){
                //清空辅导课
            this.tutorialList = []
             this.sumPrice = '-';
              this.formData.turoialIdsArray = []
            let that = this;
            that.getTutorialOptions();
        },
        onTuroialChange(value){
            this.tutorialList = []
            console.log(value)
            this.tutorialOptions.map((item,index)=>{
                value.map((list)=>{
                    if(list.indexOf(item.id)!=-1){
                        this.tutorialList.push(item)
                    } 
               })         
            })
            console.log(this.tutorialList)
        },
        onPlaceIdChange(value){
             //清空辅导课
            // this.tutorialList = []
            //  this.sumPrice = '-';
            console.log(value)
            let that = this;
            that.formData.turoialIdsArray = [];
             //查询科目
            window.Global.get('/subject/itemList',{
                placeId:value,
                status: 1
            },rs => {
                console.log(rs);
                if(rs.status==200){
                    that.subjectOptions =  rs.data.result;
                    console.log(that.subjectOptions)
                }
            })
            //查询乐理
            window.Global.get('/subject/itemList',{
                placeId:value,
                hasTheory:1,
                status: 1
            },rs => {
                console.log(rs);
                if(rs.status==200){
                    that.theoryOptions =  rs.data.result;
                }
            })
            this.formData.subjectId = ""
            this.formData.subjectLevelId = ""
            this.formData.theoryId = ""
            this.formData.turoialIdsArray = []
            //清空辅导课
            this.tutorialList = []
             this.sumPrice = '-';
        },
        onSubjectChange(value,item){
              //清空辅导课
            this.tutorialList = []
            console.log('onSubjectChange');
            console.log(value);
            let that = this;
            if(!value){
                return ;
            }
            delete that.formData.subjectLevelId;
            that.levelOptions = [];
            that.subjectOptions.map(subject => {
                if(subject.id == value){
                    that.levelOptions = [...subject.child]
                    return ;
                }
            })
            that.getTutorialOptions();
               //清空辅导课
            this.tutorialList = []
             this.sumPrice = '-';
             this.formData.turoialIdsArray = []
        },
        //查询辅导课
        getTutorialOptions(){
            let that = this;
            that.tutorialOptions = [];
            let params = {
                id:0,
                type:0,
                status: 1,
                placeId: ""
            }
            if(that.formData.sign_type==1){
                //科目
                if(that.formData.subjectLevelId){
                    console.log(that.formData.subjectLevelId)
                    params = {
                        id:that.formData.subjectLevelId,
                        type:0,
                        status:1,
                        placeId: that.formData.placeId
                    };
                }else{
                    return ;
                }
            }else{
                //乐理
                if(that.formData.theoryId){
                    console.log(that.formData.theoryId)
                    params = {
                        id:that.formData.theoryId,
                        type:1,
                        status:1,
                        placeId: that.formData.placeId
                    };
                }else{
                    return ;
                }
            }
            window.Global.get('/tutorial/typeList',params,rs => {
                if(rs.data.status==200){
                    that.tutorialOptions =  rs.data.result;
                }else{
                    self.$message.error(rs.data.message);
                }
            })
        },
        //费用
        getSumPirce : function () {
            let that = this;
            if(that.formData.sign_type==1){
                //科目
                if(!that.formData.subjectLevelId){
                    that.sumPrice = '-';
                    console.log('subjectLevelId');
                    return ;
                }else {
                    window.Global.get('/sign/sumPirce',{
                        'subjectLevelId':that.formData.subjectLevelId,
                        'turoialIds':JSON.stringify(that.formData.turoialIdsArray),
                        'cardCode':that.formData.cardCode,
                    },rs => {
                        console.log('sumpricers',rs);
                        if(rs.data.status==200){
                            that.sumPrice =  rs.data.result;
                        }else{
                            that.$message.error(rs.data.message);
                        }
                    })
                }
            }else{
                //乐理
                if(!that.formData.theoryId){
                    that.sumPrice = '-';
                    return ;
                }else {
                    console.log(112234567890876546789765)
                    window.Global.get('/sign/sumPirce',{
                        'theoryId':that.formData.theoryId,
                        'turoialIds':JSON.stringify(that.formData.turoialIdsArray)
                    },rs => {
                        console.log(that.formData.turoialIdsArray)
                        if(rs.data.status==200){
                            that.sumPrice =  rs.data.result;
                        }else{
                            that.$message.error(rs.data.message);
                        }
                    })
                }
            }
        },
        //检查是否需要审核照片
        picAuditIsShow(){
            let that = this;
            that.picAuditShow = false;
            if(that.formData.sign_type==1){
                //科目
                if(!that.formData.subjectLevelId){
                    return ;
                }else {
                    that.levelOptions.map(item => {
                        if(item.id == that.formData.subjectLevelId){
                            that.picAuditShow = item.status==1 ? true :false;
                            return ;
                        }
                    });
                }
            }
        },
        submitForm(formName) {
            let self = this;
            console.log(moment(self.formData.birthday_m).format('YYYY-MM-DD'));
            let flag = true;
            //选填项的校验
            if(self.formData.cityIdPath.length==0){
                self.$message.error('请先选择下属单位');
                flag=false;
            }
            if(!self.formData.placeId){
                self.$message.error('请选择考点');
                flag=false
              console.log(1234567890876543)
            }
            if(self.formData.sign_type==1){
                if(!self.formData.subjectLevelId){
                    self.$message.error('请选择科目及级别');
                    flag = false;
                }else{
                    flag=true;
                }   
            }else{
                if(!self.formData.theoryId){
                    self.$message.error('请选择乐理');
                    flag = false;
                }else{
                    flag=true;
                }   
            }
            if(self.formData.email){
                let reg=/^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if(!reg.test(self.formData.email)){
                    self.$message.error('请输入正确的邮箱格式');
                    flag = false;
                }else{
                    flag=true;
                } 
            }else{
                flag=true;
            }
            if(!self.formData.pic){
                self.$message.error('请上传证件照');
                flag=false;
            }
            if(self.picAuditShow){
                console.log(self.picAuditShow)
                 if(!self.formData.picAudit ){
                    self.$message.error('请上传证件照');
                    flag=false;
                }
            } else {
                self.formData.picAudit =''
            }
            self.formData.cityId = self.formData.cityIdPath[self.formData.cityIdPath.length-1];
            self.formData.birthday = moment(self.formData.birthday_m).format('YYYY-MM-DD');
            self.formData.turoialIds = JSON.stringify(self.formData.turoialIdsArray);

            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //自定义验证表单
                    if(flag){
                        self.handleSign(1)
                        console.log(this.formData)
                    }
                    //调用提交表单
                } else {
                    console.log('error submit!!');
                    // return false;
                    self.$message.error('请完善必填信息');
                }
            });
        },
        //确认提交表单
        confirmData(){
            let self = this;
            self.dialogSignVisible=false
            this.handleSign(2)
        },
        //确认报名信息
        handleSign(type){
                let urls
                let self=this
                if(type==1){
                    urls='/sign/isSure'
                }else{
                    urls='/sign/add'
                }
                 window.Global.post(urls,self.formData,rs => {
                        console.log(rs);
                      if(type==2){
                          if(rs.data.status==200){
                            self.$message.success('报名成功');
                            if(rs.data.result.status == 2){
                                //弹出支付对话框
                                self.signId = rs.data.result.signId;
                                self.payVisible = true;
                            }else{
                                alert('无需支付,直接跳报名列表或刷新详情');
                                self.$router.push({name:"indexSign"});
                            }
                        }else{
                            self.$message.error(rs.data.message);
                        }
                      }else{
                          //确认报名处理
                          console.log(rs.data)
                            if(rs.data.status==200){
                                console.log(rs.data)
                                self.confirmSign=rs.data.result
                                self.dialogSignVisible=true
                            }else{
                                self.dialogSignVisible=false
                                self.$message.error(rs.data.message)
                            }
                      }
                    });
        },
      handleAvatarSuccess(res, file) {
        this.imageUrl = URL.createObjectURL(file.raw);
      },
        beforePicUpload(file){
          return this.beforeUpload(file,'pic');
        },
         beforePicAuditUpload(file){
          return this.beforeUpload(file,'picAudit');
        },
      beforeUpload(file,field) {
          let that = this;
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG && !isPNG) {
          this.$message.error('上传头像图片只能是 JPG 或者PNG 格式!');
            return false
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
            return false
        }
          let formdata = new FormData();
          console.log(file);
          formdata.append('file',file);
          formdata.append('action','test');

          console.log('上传1');
          console.log(formdata);
          //self.saveLoading = true;
          window.Global.upload('/image/upload',formdata,rs => {
              console.log(rs.data);
              if(rs.data.status==200){
                  that.formData[field] = rs.data.result.url ;
                  that.$message.success('上传成功')
              }else{
                  that.$message.error(rs.data.message);
              }
          });
          return false // false就是不自动上传，我后来试了发现都一样，都不会自动上传
      },
        payCancel(){
          //取消支付,跳转到报名列表或者刷新详情页面
            alert('取消支付,跳转到报名列表或者刷新详情页面')
          this.payVisible = false;
            this.$router.push({name:"indexSign"});
        },
        payDone(){
            alert('支付成功,跳转到报名列表或者刷新详情页面')
            //支付成功,跳转到报名列表或者刷新详情页面
          this.payVisible = false;
            this.$router.push({name:"indexSign"});
        },
    },
    watch: {
        'formData.sign_type': function (value) {
            this.formData.subjectId = ""
            this.formData.subjectLevelId = ""
            this.formData.theoryId = ""
            this.levelOptions = ""
            this.formData.turoialIdsArray = []
             this.sumPrice = '-';
            //清空辅导课
            this.tutorialList = []
            this.getSumPirce();
            this.picAuditIsShow();
        },
        'formData.subjectLevelId': function (value) {
              
            this.getSumPirce();
            this.picAuditIsShow();
        },
        'formData.turoialIdsArray': function (value) {
           this.getSumPirce();
           console.log(value)
        },
        'formData.theoryId': function (value) {
            if(this.tutorialOptions.length>0){

            }else{
                this.formData.turoialIdsArray=[]
            }
            console.log(value)
            this.getSumPirce();
        }
    },
    filters:{
        picUrl(src){
            return window.Global.imgUrl+src; // 测试
            // return  window.Global.domain+src; // 生产
        }
    }
}
</script>
<style lang="less">
@import '../../static/less/fillForm.less';
.fillForm .el-form-item .el-form-item__content{
    font-size: 12px;
}
.boldName{
    font-weight: 700;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/fillFrom.vue